if (!customElements.get('bmb-lego-nav')) {
  class BmbLegoNav extends HTMLElement {
    constructor() {
      super();
      this.details = this.closest('details');
      this.overlay = this.querySelector('[data-bmb-lego-overlay]');
      this.drawer = this.querySelector('[data-bmb-lego-drawer]');
      this.sectionButtons = [...this.querySelectorAll('[data-bmb-lego-section-trigger]')];
      this.sections = [...this.querySelectorAll('[data-bmb-lego-section]')];
      this.panelButtons = [...this.querySelectorAll('[data-bmb-lego-trigger]')];
      this.panels = [...this.querySelectorAll('[data-bmb-lego-panel]')];
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onToggle = this.onToggle.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);
      this.details?.addEventListener('toggle', this.onToggle);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('keydown', this.onKeydown);
      this.details?.removeEventListener('toggle', this.onToggle);
      document.documentElement.classList.remove('bmb-lego-nav-open');
    }

    onToggle() {
      const isOpen = Boolean(this.details?.open);
      document.documentElement.classList.toggle('bmb-lego-nav-open', isOpen);
      if (!isOpen) {
        this.resetPanels();
        this.resetSections();
      }
    }

    onClick(event) {
      const closeTarget = event.target.closest('[data-bmb-lego-close]');
      const sectionTrigger = event.target.closest('[data-bmb-lego-section-trigger]');
      const panelTrigger = event.target.closest('[data-bmb-lego-trigger]');

      if (closeTarget || event.target === this.overlay) {
        this.close();
        return;
      }

      if (sectionTrigger) {
        this.openSection(sectionTrigger.dataset.bmbLegoSectionTrigger);
        return;
      }

      if (panelTrigger) this.openPanel(panelTrigger.dataset.bmbLegoTrigger);
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.details?.open) this.close();
    }

    openPanel(panelId) {
      this.panelButtons.forEach((button) => {
        const isActive = button.dataset.bmbLegoTrigger === panelId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-expanded', String(isActive));
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.bmbLegoPanel !== panelId;
      });

      this.drawer?.classList.add('is-panel-open');
      this.querySelector('[data-bmb-lego-panel="' + panelId + '"] a')?.focus();
    }

    openSection(sectionId) {
      this.sectionButtons.forEach((button) => {
        const isActive = button.dataset.bmbLegoSectionTrigger === sectionId;
        button.classList.toggle('bmb-lego-drawer__tab--active', isActive);
        button.setAttribute('aria-selected', String(isActive));
      });

      this.sections.forEach((section) => {
        section.hidden = section.dataset.bmbLegoSection !== sectionId;
      });

      this.resetPanels();
    }

    resetPanels() {
      this.drawer?.classList.remove('is-panel-open');
      this.panelButtons.forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-expanded', 'false');
      });
      this.panels.forEach((panel) => {
        panel.hidden = true;
      });
    }

    resetSections() {
      this.sectionButtons.forEach((button) => {
        const isShop = button.dataset.bmbLegoSectionTrigger === 'shop';
        button.classList.toggle('bmb-lego-drawer__tab--active', isShop);
        button.setAttribute('aria-selected', String(isShop));
      });
      this.sections.forEach((section) => {
        section.hidden = section.dataset.bmbLegoSection !== 'shop';
      });
    }

    close() {
      this.details?.removeAttribute('open');
      this.details?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('bmb-lego-nav-open');
      this.resetPanels();
      this.resetSections();
    }
  }

  customElements.define('bmb-lego-nav', BmbLegoNav);
}
